import { instance as axios } from "../../configs/axios";

export default {
  index: () => axios.post("User"),
  getUsers: () => axios.get("User/GetUsers"),
  getUserById: (id) => axios.get(`User/GetUserById?Id=${id}`),
  createUser: (param) => axios.post("User/CreateUser", param),
  updateUser: (param) => axios.post("User/UpdateUser", param),
  resetPasswordUser: (param) => axios.post("User/ResetPasswordUser", param),
  deleteUser: (id) => axios.post(`User/DeleteUser?Id=${id}`),
  unlockUser: (id) => axios.post(`User/UnlockUser?Id=${id}`),
  changeActiveStatus: (param) => axios.post(`User/ChangeActiveStatus`, param),
  logout: () => axios.post("Auth/Logout", {}),
};